/** Tracking parameters carried from the landing page over to Shopify. */
const TRACKED_PARAMS = [
  'utm_source',
  'utm_campaign',
  'utm_medium',
  'utm_content',
  'utm_term',
  'utm_id',
  'fbclid',
  'gclid',
  'ttclid',
]

/**
 * Appends the tracking parameters present in the current page URL to a
 * destination URL, without overwriting parameters the destination already has.
 */
export function withUtms(url: string): string {
  if (typeof window === 'undefined') return url

  try {
    const current = new URLSearchParams(window.location.search)
    const destination = new URL(url, window.location.href)

    TRACKED_PARAMS.forEach((param) => {
      const value = current.get(param)
      if (value && !destination.searchParams.has(param)) {
        destination.searchParams.set(param, value)
      }
    })

    return destination.toString()
  } catch {
    return url
  }
}
